import React from 'react';
import PropTypes from 'prop-types';

import { CallTo, MailTo } from 'components/common';

const Offices = ({
  frameUrl, titleLeft, titleRight, address, tel, fax, mail,
}) => (
  <div className="im-box im-box--white im-box--shadow im-box--no-radius im-box--padding-0 im-box--mh-100">
    <div className="row">
      <div className="col">
        <iframe
          title="map"
          src={frameUrl}
          width="100%"
          height="300"
          frameBorder="0"
          style={{ border: 0 }}
          aria-hidden="false"
        />
      </div>
    </div>
    <div className="row">
      <div className="col">
        <div className="p-40">
          <div className="mb-3">
            <span className="fs-20 text-black1">
              <span className="fw-900">{titleLeft}</span>
              <span className="text-gray10">{` | ${titleRight}`}</span>
            </span>
          </div>
          <div className="mb-3">
            <span className="lh-1p4">{address}</span>
          </div>
          <ul className="has-child-margins">
            <li>
              <span style={{ color: '#6f6f6f', fontWeight: '900' }}>
                T:
                {' '}
                <CallTo className="fw-400" tel={tel} />
              </span>
            </li>
            <li>
              <span style={{ color: '#6f6f6f', fontWeight: '900' }}>
                F:
                {' '}
                <CallTo className="fw-400" tel={fax} />
              </span>
            </li>
            <li>
              <span style={{ color: '#6f6f6f', fontWeight: '900' }}>
                M:
                {' '}
                <MailTo className="fw-400" mail={mail} />
              </span>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
);

Offices.propTypes = {
  frameUrl: PropTypes.string,
  titleLeft: PropTypes.string,
  titleRight: PropTypes.string,
  address: PropTypes.string,
  tel: PropTypes.string,
  fax: PropTypes.string,
  mail: PropTypes.string,
};

export default Offices;
